module.exports = __webpack_public_path__ + "img/7.98db5095.jpg";